import React, { useEffect, useRef, useState } from 'react';

import { PromoEmptyPage } from 'apps/promo/components/form/PromoInputPhoneWithDropdown/PromoEmptyPage';
import { PromoSearchBar } from 'apps/promo/components/form/PromoInputPhoneWithDropdown/PromoSearchBar';
import { getArticles } from 'apps/promo/components/help/utils';
import { getHighlightedText, getLangCountryPrefix, resolveArguments } from 'apps/promo/helpers/utils';

import styles from '../../pages/help-mobile/ZendeskHelpMobile.module.css';
import { LightIcon } from '../common/fromAuth/LightIcon/LightIcon';
import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';
import { LightText } from '../common/fromAuth/LightText/LightText';
import { getHelpCenterUrl, useDebounce, useGetQueryParams } from '../utils';
import PromoModalComponent from '../utils/PromoModalComponent';

export const ZendeskHelpMobileSearchModal = (props) => {
    const urlParams = useGetQueryParams();
    const searchRef = useRef(null);

    const [search, setSearch] = useState('');
    const [foundArticles, setFoundArticles] = useState({
        articlesList: [],
        query: '',
    });

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;

    const debouncedSearch = useDebounce(search, 1000);

    useEffect(() => {
        const fetchData = async (query) => {
            if (!query) {
                return;
            }

            const articles = await getArticles(props.lang, props.country, query, props.sections);

            if (articles) {
                const filteredArticles = articles.filter((article) => !article.directLink);
                setFoundArticles({
                    articlesList: filteredArticles,
                    query: query,
                });
            }
        };

        fetchData(debouncedSearch);
    }, [debouncedSearch]);

    const articlesNames = foundArticles?.articlesList?.map((article) => {
        return (
            <a
                className={styles.mobileHelpLink}
                key={article.id}
                href={getHelpCenterUrl(`${url}/category/${article.category_id}/section/${article.section_id}/article/${article.id}`, urlParams)}
            >
                {!!foundArticles?.query ? (
                    <span>{getHighlightedText(foundArticles?.query, article.title, 'lightText', {}, props.useThemeColor)}</span>
                ) : (
                    <LightText>{article.title}</LightText>
                )}
                <LightIcon name="chevron-right" color="primary" leftIndent={'16px'} />
            </a>
        );
    });

    return (
        <PromoModalComponent canCloseModal={false} useThemeColor={props.useThemeColor}>
            {articlesNames?.length === 0 && search && (
                <PromoEmptyPage
                    showChat={false}
                    chatButton={props.chatButton}
                    chatButtonType={props.chatButtonType}
                    chatButtonHref={props.chatButtonHref}
                    toggleChat={props.toggleChat}
                    notFoundMessage={resolveArguments(props.searchNoResult, search)}
                    useThemeColor={props.useThemeColor}
                    hasFixedIndent={props.hasFixedIndent}
                />
            )}
            {articlesNames?.length > 0 && search && <div>{articlesNames}</div>}
            <LightNavBar isSearchBar>
                <PromoSearchBar
                    searchRef={searchRef}
                    placeholder={props.searchPlaceholder}
                    onChange={(e) => setSearch(e.target.value)}
                    onCloseButtonClick={props.toggleSearch}
                    useThemeColor={props.useThemeColor}
                />
            </LightNavBar>
        </PromoModalComponent>
    );
};
